export type ChatListMode = "private" | "shared" | "public";
const chatListModeKey = "chatListMode";
export function getChatListMode(): ChatListMode {
  return (localStorage.getItem(chatListModeKey) as ChatListMode) || "private";
}

export function setChatListMode(mode: ChatListMode) {
  localStorage.setItem(chatListModeKey, mode);
}
